<template>
  <div>
    <detail-layout ref="layout" :tableCfg="tableCfg">
      <template slot="FormLayout" scope="props">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
          <div v-if="dataValid" >
            <div class="row">
              <detail-field class="col-md-6" label="Invoice/Contract/Student" field="invoice_id" :optionListApiUrl="'/invoices/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Amount Paid" field="amount_paid" @input="onCalcNetAmount(props.rec, $event)" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Commission" field="commission" @input="onCalcNetAmount(props.rec, $event)" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Net Amount" field="net_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Payment Date" field="payment_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="required" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Comments" field="comments" type="textarea" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row" v-if="!isNew" >
              <detail-field class="col-md-6" label="Created" field="creation_timestamp" field2="creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Last Edit" field="edit_timestamp" field2="edit_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="PDF Creation" field="pdf_creation_timestamp" field2="pdf_creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field vclass="col-md-6" label="Payment Confirmation" field="payment_confirmation_timestamp" field2="payment_confirmation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
            </div>
          </div>
        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item v-if="props.rec && privDeveloper && isReadOnly" @click="createPDF(props.rec)">Create PDF</b-dropdown-item>
            <b-dropdown-item v-if="props.rec && props.rec.number !== null && isReadOnly" @click="downloadPDF(props.rec)">Download PDF</b-dropdown-item>
            <b-dropdown-item v-if="props.rec && props.rec.number !== null && privUser && isReadOnly" @click="sendEmail(props.rec)">Send Payment Confirmation</b-dropdown-item>
          </b-dropdown>
      </template>
    </detail-layout>
  </div>
</template>

<script>
import api from '../../api'
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'invoice_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
    onCalcNetAmount (rec) {
      // console.log('onCalcNetAmount', rec.amount_paid, rec.commission, Number(rec.amount_paid), Number(rec.commission))
      rec.net_amount = Number(rec.amount_paid) - Number(rec.commission)
    },
    createPDF (rec) {
      // console.log(rec)
      api.post('/invoice_payments/' + rec.id + '/create_pdf', {},
      data => { },
      'creating pdf', this.$refs.layout.$refs.alert)
    },
    downloadPDF (rec) {
      // console.log(rec)
      api.downloadPost('/invoice_payments/' + rec.id + '/download_pdf', {}, rec.pdf_filename)
    },
    sendEmail (rec) {
      // console.log(rec)
      api.post('/invoice_payments/' + rec.id + '/send_email', {},
      data => {
        this.$refs.layout.$refs.alert.appendMessage('Email sent' + '<br/>')
      },
      'sending email', this.$refs.layout.$refs.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?7ad2379a